var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fd6ed31b458fd53acfbb40bfb4b07efef280043e"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["3blue1brown-llc@3blue1brown-llc"]={id:"fd6ed31b458fd53acfbb40bfb4b07efef280043e"};
      